export default __webpack_public_path__ + "static/media/txt2_sp.c8626694.png";